import './index.scss';
import React from 'react';
const RestaurantOrderType = props => {
  const { type, onChange, leftValue, rightValue, isOffer, theme } = props;
  return (
    <>
      {!window.sessionStorage.getItem('THEATRE_RESPONSE') ? (
        <div className={`rst-or-type ${isOffer ? 'rst-or-type_offer' : ''}`}>
          <div
            role="presentation"
            onClick={() => onChange(leftValue)}
            className={`u_cursor_pointer rst-or-type__item ${theme} ${
              type === leftValue ? 'rst-or-type__item_active' : ''
            }`}
          >
            {leftValue}
          </div>
          <div
            role="presentation"
            onClick={() => onChange(rightValue)}
            className={`u_cursor_pointer rst-or-type__item ${theme} ${
              type === rightValue || type === 'in restaurant'
                ? `rst-or-type__item_active ${
                    type === 'on delivery'
                      ? 'rst_or_type__item_active-delivery'
                      : ''
                  }`
                : ''
            }`}
          >
            {rightValue}
          </div>
        </div>
      ) : (
        <div className="dinein-theatre">
          <div className="dinein-theatre-title">DINEIN - THEATRE</div>
        </div>
      )}
    </>
  );
};
export default RestaurantOrderType;
